<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Search Previously Used Payment Descriptions</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Cancel
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-text-field
                label="Search"
                prepend-icon="mdi-magnify"
                v-model="full_text"
                v-on:input="update"
                style="margin-top: 15px"
                autocomplete="off"
            >
            </v-text-field>

            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results_objs"
                :items-per-page="100"
                class="elevation-1"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
                @click:row="onClickRow"
            >

                 <template v-slot:item.action="{  }">
                    <a>Use</a>
                </template>
            
            </v-data-table>

        
        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,
            full_text: null,
            results: [],

            headers: [
                { text: 'Payment Description', value: 'desc'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.dialog = false;
            next(false);
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/payments/descriptions',
            
                {
                    'organization_id': this.$rc.$state.getOrganizationId(),
                    'full_text': this.full_text
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to list previous payment descriptions');
                },
            );
        },

        onClickRow(row)
        {
            this.closeDialog();
            this.$emit('input', row.desc);
        },
        
    },

    computed: {
        results_objs() {
            let ret = [];

            for ( let i = 0; i < this.results.length; i++ )
            {
                ret.push({'desc': this.results[i]});
            }

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>